import React from "react";
import { Box, Typography } from "@mui/material";

const QueryBuilderHero = ({ subtitle }) => (
  <Box sx={{ mb: 2 }}>
    <Typography variant="h3" fontWeight={800} sx={{ mb: 0.5 }}>
      Stat Explorer
    </Typography>
    <Typography color="text.secondary">
      {subtitle || "Browse careers and seasons with visual filters and shareable URLs."}
    </Typography>
  </Box>
);

export default QueryBuilderHero;
